import { fitRect } from '../image-positioning/fit-rect';
import { isPositiveSize } from '../image-positioning/geometry-guards';

interface Size {
  readonly width: number;
  readonly height: number;
}

export const FOLD_SHEET_TOLERANCE_PERCENT = 10;

/** Aspect delta, % of the sheet aspect: |tW/tH − sW/sH| / (sW/sH), cross-multiplied so integer px compare exactly. */
function aspectDeltaPercent(template: Size, sheet: Size): number {
  return (Math.abs(template.width * sheet.height - sheet.width * template.height) * 100) / (sheet.width * template.height);
}

/** Template placed on a трюмо sheet: cover, centre anchor; null when aspects differ by more than 10 %. */
export function foldSheetFit(template: Size, sheet: Size): { scale: number; offsetX: number; offsetY: number } | null {
  if (!isPositiveSize(template.width, template.height, sheet.width, sheet.height)) return null;
  if (aspectDeltaPercent(template, sheet) > FOLD_SHEET_TOLERANCE_PERCENT) return null;
  const rect = fitRect(template.width, template.height, sheet, { mode: 'cover', round: false });
  return { scale: rect.width / template.width, offsetX: rect.left, offsetY: rect.top };
}

/** Aspect delta rounded to whole percent. */
export function foldSheetFitPercent(template: Size, sheet: Size): number {
  return Math.round(aspectDeltaPercent(template, sheet));
}
